import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	getRoles,
	createRole,
	updateRole,
	deleteRole,
	rolService,
} from "../services/role.service";

// Re-export types for convenience
export type { RoleRequest, RoleUpdateRequest } from "../services/role.service";

export const useGetActiveRolesByAccountId = () => {
	return useQuery({
		queryKey: ["active-roles"],
		queryFn: rolService.findActiveRolesByAccountId,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

export const useGetRoles = (search?: string) => {
	return useQuery({
		queryKey: ["roles", search],
		queryFn: () => getRoles(search),
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
};

export const useCreateRole = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: createRole,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["roles"] });
		},
	});
};

export const useUpdateRole = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateRole,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["roles"] });
		},
	});
};

export const useDeleteRole = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteRole,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["roles"] });
		},
	});
};
